import { ButtonGroup } from "../atoms/buttons"
import { InputFile } from "../atoms/input"
import { VerticalLayout, HorizontalLayout } from "../components/layout"
import { SettingHeader } from "./SettingHeader"
import { useState } from "react"

export const ThemeBrandingContent = function ({ setLogo,branding }) {
    const [localLogo, setLocalLogo] = useState(null);
    const [alignment, setAlignment] = useState('left'); 
    console.log("logo", localLogo)
    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setLocalLogo(file);       
            setLogo({ logo_url: file, alignment: alignment });
        }
    }
    const handleAlignmentChange = (newAlignment) => {
        setAlignment(newAlignment);
        if(localLogo === null)
        setLogo({alignment: newAlignment }); 
        else
        setLogo({ logo_url: localLogo, alignment: newAlignment }); 
    };
    const alignmentButtons = [
        {
          id: 'left',
          content: 'Left',
          onClick: () => handleAlignmentChange('left'),
          selected: alignment === 'left',
        },
        {
          id: 'center',
          content: 'Center',
          onClick: () => handleAlignmentChange('center'),
          selected: alignment === 'center',
        },
        {
          id: 'right',
          content: 'Right',
          onClick: () => handleAlignmentChange('right'),
          selected: alignment === 'right',
        },
      ];
    return (
        <VerticalLayout className={"theme-create-content"} >
            <SettingHeader
                title="Branding"
                description="Voeg je eigen logo toe"
            />
            <div className="phone-no-padding-left" style={{padding: "0px 1rem"}}>
                <div className="branding-option">
                    <InputFile fileChange={handleLogoChange} title={"Logo"} supporting={"png, jpg/jpeg, svg zijn toegestaan"} icon2={"upload"} accept={".png, .jpg, .jpeg .svg"}/>
                    <HorizontalLayout>
                     <ButtonGroup size={"large"} buttons={alignmentButtons} />
                    </HorizontalLayout>
                </div>
            </div>
        </VerticalLayout>
    )
}